// src/sections/Store.js
import React, { useRef } from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

import './Store.css';
import { gsap } from 'gsap';

// 画像をインポート
import item1Img from '../assets/KoukakuKidoutai_ArtCollection_1.jpg';
import item2Img from '../assets/Fuzichoco_TokimekiCollection.png';
import item3Img from '../assets/IdentityV_CreatorCollab_KyotoNEO_1.jpg';
import item4Img from '../assets/IdentityV_CreatorCollab_KyotoNEO_2.jpg';
import item5Img from '../assets/KoukakuKidoutai_ArtCollection_2.jpg';
import item6Img from '../assets/KoukakuKidoutai_ArtCollection_1.jpg';
import item7Img from '../assets/Fuzichoco_TokimekiCollection.png';
import item8Img from '../assets/IdentityV_CreatorCollab_KyotoNEO_1.jpg';
import item9Img from '../assets/IdentityV_CreatorCollab_KyotoNEO_2.jpg';
import item10Img from '../assets/KoukakuKidoutai_ArtCollection_2.jpg';

const storeItems = [
  { id: 1, name: '攻殻機動隊 アートコレクション', image: item1Img, url: 'https://shop.wonder-story.jp/pages/reflame_the_ghost' },
  { id: 2, name: '藤ちょこ先生TOKIMEKIコレクション', image: item2Img, url: 'https://shop.wonder-story.jp/collections/tokimeki24' },
  { id: 3, name: '第五人格 クリエイターコラボKYOTO NEO', image: item3Img, url: 'https://shop.wonder-story.jp/collections/idv-re-2025' },
  { id: 4, name: '第五人格 クリエイターコラボKYOTO NEO', image: item4Img, url: 'https://shop.wonder-story.jp/collections/idv-re-2025' },
  { id: 5, name: '攻殻機動隊 アートコレクション', image: item5Img, url: 'https://shop.wonder-story.jp/pages/reflame_the_ghost' },
  { id: 6, name: '攻殻機動隊 アートコレクション', image: item6Img, url: 'https://shop.wonder-story.jp/pages/reflame_the_ghost' },
  { id: 7, name: '藤ちょこ先生TOKIMEKIコレクション', image: item7Img, url: 'https://shop.wonder-story.jp/collections/tokimeki24' },
  { id: 8, name: '第五人格 クリエイターコラボKYOTO NEO', image: item8Img, url: 'https://shop.wonder-story.jp/collections/idv-re-2025' },
  { id: 9, name: '第五人格 クリエイターコラボKYOTO NEO', image: item9Img, url: 'https://shop.wonder-story.jp/collections/idv-re-2025' },
  { id: 10, name: '攻殻機動隊 アートコレクション', image: item10Img, url: 'https://shop.wonder-story.jp/pages/reflame_the_ghost' },
];

const ItemCard = ({ item }) => {
  const cardRef = useRef(null);

  const handleMouseEnter = () => {
    gsap.to(cardRef.current, { scale: 1.05, duration: 0.3 });
  };

  const handleMouseLeave = () => {
    gsap.to(cardRef.current, { scale: 1, duration: 0.3 });
  };

  const handleClick = () => {
    window.open(item.url, '_blank'); // 新しいタブで開く
  };

  return (
    <div
      className="item-card"
      ref={cardRef}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      onClick={handleClick}
      style={{ cursor: 'pointer' }}
    >
      <div className="item-image-container">
        <img src={item.image} alt={item.name} loading="lazy" decoding="async" className="item-image" />
      </div>
      <p className="item-name">{item.name}</p>
    </div>
  );
};

function SampleNextArrow(props) {
  const { className, onClick } = props;
  return (
    <div className={`${className} arrow-button slick-next-custom`} onClick={onClick}>
      <span className="arrow-icon"></span>
    </div>
  );
}

function SamplePrevArrow(props) {
  const { className, onClick } = props;
  return (
    <div className={`${className} arrow-button slick-prev-custom`} onClick={onClick}>
      <span className="arrow-icon"></span>
    </div>
  );
}

function Store() {
  const sliderRef = useRef(null);

  const settings = {
    centerMode: true,
    centerPadding: '0px',
    slidesToShow: 5,
    infinite: true,
    speed: 500,
    dots: false,
    lazyLoad: 'ondemand',
    waitForAnimate: true,
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />,
    focusOnSelect: true,
    responsive: [
      { breakpoint: 1400, settings: { slidesToShow: 5, centerMode: true, centerPadding: '0px' } },
      { breakpoint: 1200, settings: { slidesToShow: 5, centerMode: true, centerPadding: '0px' } },
      { breakpoint: 992, settings: { slidesToShow: 3, centerMode: true, centerPadding: '0px' } },
      { breakpoint: 768, settings: { slidesToShow: 3, centerMode: true, centerPadding: '0px' } },
      { breakpoint: 576, settings: { slidesToShow: 1, centerMode: true, centerPadding: '0px' } },
      { breakpoint: 480, settings: { slidesToShow: 1, centerMode: true, centerPadding: '0px' } }
    ]
  };

  return (
    <section id="store" className="store-section">
      <h2 className="section-title">STORE</h2>
      <div className="store-carousel-container">
        <Slider ref={sliderRef} {...settings}>
          {storeItems.map(item => (
            <div key={item.id}>
              <ItemCard item={item} />
            </div>
          ))}
        </Slider>
        <div className="store-ec-button-wrapper">
          <a
            href="https://shop.wonder-story.jp"
            target="_blank"
            rel="noopener noreferrer"
            className="store-ec-button"
          >
            EC
          </a>
        </div>
      </div>
    </section>
  );
}

export default Store;
